"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.pluginLineSpacing=function(config){return void 0===config&&(config={}),{config:config,type:"line-spacing"}};
//# sourceMappingURL=module.viewer.cjs.js.map
